import {
    Button, Dialog,
    DialogActions,
    DialogContent,
    DialogSurface,
    DialogTitle,
    DialogTrigger,
    Tooltip
} from "@fluentui/react-components";
import {
    ArrowExportLtr20Regular,
    Chat20Regular,
    Home20Regular,
    People20Regular,
    Settings20Regular
} from "@fluentui/react-icons";
import Icon from "../assets/klokking-icon.png"
import {signOutUser} from "../handlers/userhandler";
import {navigateToPage} from "../handlers/routehandler";

const SideNavBar = () => {
    const packageJson = require('../../package.json');

    return (
        <>
            <div className={`side-nav`}>
                <div className={`side-nav-container`}>
                    <Tooltip content="Home" relationship="label">
                        <Button as={`a`} className={`button`} icon={<Home20Regular/> } onClick={() => navigateToPage(``)} />
                    </Tooltip>
                </div>
                <div className={`side-nav-container`}>
                    <Tooltip content="Participants" relationship="label">
                        <Button as={`a`} className={`button`} icon={<People20Regular/> } onClick={() => navigateToPage(`participants`)} />
                    </Tooltip>
                    <Tooltip content="Settings" relationship="label">
                        <Button as={`a`} className={`button`} icon={<Settings20Regular/> } onClick={() => navigateToPage(`account`)} />
                    </Tooltip>
                    <Dialog>
                        <DialogTrigger>
                            <Tooltip content="Get in contact" relationship="label">
                                <Button as={`a`} className={`button`} icon={<Chat20Regular/> }/>
                            </Tooltip>
                        </DialogTrigger>
                        <DialogSurface className={`dialog`}>
                            <DialogTitle>Get in contact</DialogTitle>
                            <DialogContent>
                                <p style={{ display: "inline-block" }}>
                                    If you’re having trouble with registration, curious about our features,
                                    or want to get more information about Klokking? Get in contact with us!
                                    <br/>
                                    Click the button below or send us a mail via: <a className={`a-no-underline`} href={`mailto:klokking@pm.me`}>klokking@pm.me</a>
                                </p>
                                <p className={`text-sub text-no-margin`} style={{ display: "inline-block" }}>Klokking is developed by <a className={`a-no-underline`} href="https://gadijkhuis.nl/" target="_blank" rel="noreferrer">Gideon Dijkhuis (GADijkhuis)</a></p>
                                <p className={`text-sub text-no-margin`}>&#169; { new Date().getFullYear() } Klokking </p>
                            </DialogContent>
                            <DialogActions>
                                <DialogTrigger>
                                    <Button as={`a`}>Cancel</Button>
                                </DialogTrigger>
                                <DialogTrigger>
                                    <Button as={`a`} appearance={`primary`} href={`mailto:klokking@pm.me`}>Contact us!</Button>
                                </DialogTrigger>
                            </DialogActions>
                        </DialogSurface>
                    </Dialog>
                    <Dialog>
                        <DialogTrigger>
                            <Tooltip content="Sign out" relationship="label">
                                <Button as={`a`} className={`button`} icon={<ArrowExportLtr20Regular/> } />
                            </Tooltip>
                        </DialogTrigger>
                        <DialogSurface className={`dialog`}>
                            <DialogTitle>Sign out?</DialogTitle>
                            <DialogContent>
                                Are you sure you want to sign out the current user?
                            </DialogContent>
                            <DialogActions>
                                <DialogTrigger>
                                    <Button as={`a`}>Cancel</Button>
                                </DialogTrigger>
                                <DialogTrigger>
                                    <Button as={`a`} appearance={`primary`} onClick={() => signOutUser()}>Sign out</Button>
                                </DialogTrigger>
                            </DialogActions>
                        </DialogSurface>
                    </Dialog>
                    <div className={`flex-column`}>
                        <img alt="Klokking Icon" src={Icon} className={`side-nav-icon`} />
                        <p className={`text-x-small text-no-margin text-center width-100`}>V{packageJson.version}</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SideNavBar;